const locale = "de-DE";

const amountFormat = new Intl.NumberFormat(locale, {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
});

export function formatAmount(amount: number): string {
  return amountFormat.format(amount);
}

const formatter = new Intl.DateTimeFormat(locale, {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function formatDate(date: Date | string): string {
  return formatter.format(new Date(date)); // dates are strings in JSON, so preactement passes a string
}

/**
 * Omits decimal places if the amount is an integer.
 */
export function formatPointAmount(num: number): string {
  if (num % 1 === 0) {
    return num.toString() + "€";
  } else {
    return num.toFixed(2).replace(".", ",") + "€";
  }
}
